import { makeRequest } from 'utils/requestLogger';

export default (id, students) =>
  makeRequest('post', `/api/live_discussions/${id}/force_join_students`, {
    student_ids: students,
  });



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/forceJoinStudents.js